
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import InputCheckbox from '@/components/InputCheckbox.vue';

@Component({
  components: {
    InputCheckbox
  }
})
export default class TopContentCheck extends Vue {
  @Prop({ type: Boolean, required: true })
  public value!: boolean;

  @Emit()
  public input(value: boolean) {}

  private get localValue(): boolean {
    return this.value;
  }

  private set localValue(value: boolean) {
    this.input(value);
  }
}
